/**
 * @desc 导出
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierBoxBatch.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBoxBatch/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
